import { Box } from '@mui/material';
import BaseTypography from 'core/components/typography/BaseTypography';
import { FontsEnum } from 'core/constants/enums/FontsEnum.ts';
import { SubscriptionPlanType } from 'core/constants/enums/SubscriptionPlanType.ts';
import SubscriptionCard from 'core/layouts/components/subscription-plans/components/subscription-card/SubscriptionCard';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
import React from 'react';

export default function OneTimeSubscriptionCard({
	handleSubscriptionPlanButtonClick,
	subscriptionPlans,
	isFreeUser,
}) {
	return (
		<Box
			sx={[
				reusableStyles.flexColWithGap(16),
				{
					width: 'auto',
					justifyContent: { xs: 'center', sm: 'flex-start' },
					alignItems: { xs: 'center', sm: 'flex-start' },
				},
			]}
		>
			<BaseTypography
				id="extra-credit-pack-text"
				key="extra-credits-pack-text"
				variant="t1_bold"
				styles={{
					color: 'colors.light1',
					textAlign: 'left',
					fontFamily: FontsEnum.ZODIAK,
				}}
			>
				Extra Credits pack
			</BaseTypography>
			{subscriptionPlans[SubscriptionPlanType.ONE_TIME]?.map((oneTimeSubscriptionPlan) => (
				<SubscriptionCard
					key={`subscription-${oneTimeSubscriptionPlan?.name}`}
					id={`subscription-${oneTimeSubscriptionPlan?.name}`}
					data-testid="subscription-card"
					loading={false}
					plan={oneTimeSubscriptionPlan}
					planType={SubscriptionPlanType.ONE_TIME}
					buttonText="Buy pack"
					onButtonClick={() =>
						handleSubscriptionPlanButtonClick(
							oneTimeSubscriptionPlan,
							SubscriptionPlanType.ONE_TIME,
						)
					}
					disableButton={isFreeUser}
				/>
			))}
		</Box>
	);
}
